// export default {
//     name: "Client Kyc Template",
//     path: "/client/clientKycTempList",
//     meta: {
//         icon: "cloud",
//         auth: true
//     },
//     departmentName: "Dashboard",
//     finalPagePermision: "",
//     component: require("../component/clientKycTemp/ClientKycList.vue")
// };

export default {
    name: "Client Kyc Template",
    meta: {
        icon: "directions_boat",
        expanded: true,
        auth: true,
    },
    departmentName: "Dashboard",
    finalPagePermision: "",
    children: [{
        name: "Client Kyc Template",
        path: "/client/clientKycTempList",
        permissionName: '',
        keywords: ['Client Kyc Template ', 'Client Kyc Dash'],
        meta: {
            icon: "directions_boat",
            auth: true,
        },
        component: require("../component/clientKycTemp/ClientKycList.vue"),
        finalPagePermision: "",
    }, {
        name: "Client Kyc Dash",
        path: "/kyc-temp/ClientKycDash",
        permissionName: '',
        keywords: ['Client Kyc Template ', 'Client Kyc Dash'],
        meta: {
            icon: "directions_boat",
            auth: true,
        },
        component: require("../component/clientKycTemp/ClientKycList.vue"),
        finalPagePermision: "",
    },],
};


// WEBPACK FOOTER //
// ./src/sidebar/clientKycTemp.js